import React from "react";
import {
  Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  Input, FormLabel, Grid, GridItem, useToast
} from "@chakra-ui/react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import { v4 as uuidv4 } from "uuid";
import { addTechnician, updateTechnician } from "../../utils/formsApi";
import client from "../../helpers/Client";

registerPlugin(FilePondPluginFileRename);

export default function TechniciansAddModal({ isOpen, onClose, onAdded, technician = null }) {
  const toast = useToast();
  const [uploadID, setUploadID] = React.useState(null);
  const [locked, setLocked] = React.useState(false);
  const [name, setName] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [skill, setSkill] = React.useState("");
  const [teamGroup, setTeamGroup] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const isEdit = !!(technician && technician.id);

  React.useEffect(() => {
    if (!isOpen) return;
    setUploadID(null);
    setLocked(false);
    setName(technician?.name || "");
    setFirstName(technician?.first_name || "");
    setLastName(technician?.last_name || "");
    setTitle(technician?.title || "");
    setSkill(technician?.skill || "");
    setTeamGroup(technician?.team_group || "");
    setEmail(technician?.email || "");
    setPhone(technician?.phone || "");
  }, [isOpen, technician]);

  const handleSave = async () => {
    if (!name.trim() && !firstName.trim()) {
      toast({ title: "Ad girin", status: "warning" }); return;
    }
    try {
      const payload = {
        name: name.trim() || `${firstName} ${lastName}`.trim(),
        first_name: firstName || null,
        last_name: lastName || null,
        title: title || null,
        skill: skill || null,
        team_group: teamGroup || null,
        email: email || null,
        phone: phone || null,
        upload_id: uploadID || undefined,
      };
      if (isEdit) await updateTechnician(technician.id, payload);
      else await addTechnician(payload);
      setName(""); setFirstName(""); setLastName(""); setTitle(""); setSkill(""); setTeamGroup(""); setEmail(""); setPhone("");
      setUploadID(null);
      onClose();
      if (onAdded) onAdded();
      toast({ title: isEdit ? "Teknisyen güncellendi" : "Teknisyen eklendi", status: "success" });
    } catch (e) {
      toast({ title: isEdit ? "Teknisyen güncellenemedi" : "Teknisyen eklenemedi", description: String(e?.response?.data?.detail || e.message || e), status: "error" });
    }
  };

  const renameFn = (file) => uuidv4() + file.extension;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{isEdit ? "Teknisyen Düzenle" : "Yeni Teknisyen"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={3}>
            <GridItem colSpan={{ base: 1, md: 2 }}>
              <FormLabel>Fotoğraf</FormLabel>
              <FilePond
                allowFileRename={true}
                fileRenameFunction={renameFn}
                allowMultiple={false}
                chunkUploads={true}
                chunkForce={true}
                chunkSize={1000000}
                server={{
                  url: ((client.defaults.baseURL || "").replace(/\/$/, "")) + "/fp/",
                  process: "./process/",
                  patch: "./patch/",
                  revert: "./revert/",
                  load: "./load/",
                  restore: "./restore/",
                  fetch: "./fetch/",
                }}
                onaddfilestart={() => setLocked(true)}
                onprocessfile={(_, file) => { setUploadID(file.serverId); setLocked(false); }}
                labelIdle='Fotoğrafı sürükleyin ya da <span class="filepond--label-action">seçin</span>.'
              />
            </GridItem>
            <Input placeholder="Ad (kısa ad)" value={name} onChange={(e) => setName(e.target.value)} />
            <Input placeholder="Ad" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            <Input placeholder="Soyad" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            <Input placeholder="Yetki / Ünvan" value={title} onChange={(e) => setTitle(e.target.value)} />
            <Input placeholder="Yetenek / Görev" value={skill} onChange={(e) => setSkill(e.target.value)} />
            <Input placeholder="Takım / Grup" value={teamGroup} onChange={(e) => setTeamGroup(e.target.value)} />
            <Input placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} />
            <Input placeholder="Telefon" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>Vazgeç</Button>
          <Button colorScheme="blue" onClick={handleSave} isDisabled={locked}>Kaydet</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
